module.exports = __webpack_public_path__ + "img/32.f97ef913.png";